import styled from "styled-components"

import { useAppDispatch, useAppSelector } from "store/hooks"
import { setUserTemperatureScale } from "store/userSlise"
import { StorageKeys } from "types/enums/StorageKeys"

import { setStorageItem } from "utils/localStorage"

import { ToggleButton } from "../ToggleButton"

const TemperatureToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
`

export const TemperatureToggle = () => {
  const dispatch = useAppDispatch()
  const userTemperatureScale = useAppSelector(state => state.user.userTemperatureScale)
  const isCelsius = userTemperatureScale === "celsius"

  const handleChange = () => {
    const scale = isCelsius ? "fahrenheit" : "celsius"
    setStorageItem(StorageKeys.UserTemperatureScale, scale)
    dispatch(setUserTemperatureScale(scale))
  }

  return (
    <TemperatureToggleWrapper>
      <span>°C</span>
      <ToggleButton id="temperatureToggle" name="temperatureToggle" isChecked={!isCelsius} onChange={handleChange} />
      <span>°F</span>
    </TemperatureToggleWrapper>
  )
}
